import React from "react"
import { Redirect, Route, useLocation } from "react-router"
import { useAppSelector } from "../app/hooks"

interface AuthedRouteProps {
    component: any
    path: string
    rest?: Record<string, any>
}

const AuthedRoute = ({ component: Component, path, rest }: AuthedRouteProps) => {
    const location = useLocation()
    const { isAuthed, userInfo } = useAppSelector((state) => state.auth)
    if (
        isAuthed &&
        location.pathname !== "/" &&
        !userInfo?.GroupMenu?.map((gm: Record<string, any>) => gm.Menu)
            .map((menu: Record<string, any>) => menu.route)
            .includes(location.pathname)
    ) {
        return <Redirect to={"/"} />
    }
    return isAuthed ? <Route path={path} exact={true} component={Component} /> : <Redirect to={"/login"} />
}

export default AuthedRoute
